import React from 'react';
import { Outlet } from 'react-router-dom';

import ContentErrorBoundary from '@components/ErrorBoundary/ContentError';

const FlightFlyToAnywhereLayout = () => {
  return (
    <div>
      <ContentErrorBoundary isErrorReload>
        <Outlet />
      </ContentErrorBoundary>
    </div>
  );
};

export default FlightFlyToAnywhereLayout;
